// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".PressList__heading___v-sIu{padding:0 25px}.PressList__title___2xWIU{color:inherit;font-weight:500;font-size:48px;line-height:64px;font-weight:200}@media (max-width:719px){.PressList__title___2xWIU{color:inherit;font-weight:500;font-size:40px;line-height:56px;font-weight:200}}.PressList__description___2UoJP{color:#6b6651}.PressList__yearList___1Ts0X{margin:32px 0 0}.PressList__card___7pmsE{margin-bottom:60px}.PressList__card___7pmsE:last-of-type{margin-bottom:0}@media (max-width:719px){.PressList__card___7pmsE{margin-bottom:50px}.PressList__card___7pmsE:last-of-type{margin-bottom:0}}.PressList__articlesList___XWxgM{position:relative;margin-top:60px}.PressList__button___3cvLo{margin-top:60px;margin-left:25px}@media (max-width:959px){.PressList__button___3cvLo{width:100%;margin-left:0}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"xsmall": "540px",
	"small": "720px",
	"medium": "960px",
	"large": "1280px",
	"heading": "PressList__heading___v-sIu",
	"title": "PressList__title___2xWIU",
	"description": "PressList__description___2UoJP",
	"yearList": "PressList__yearList___1Ts0X",
	"card": "PressList__card___7pmsE",
	"articlesList": "PressList__articlesList___XWxgM",
	"button": "PressList__button___3cvLo"
};
module.exports = ___CSS_LOADER_EXPORT___;
